import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M 2.498 243.991 C 2.498 378.113 111.231 486.846 245.353 486.846 C 379.479 486.846 488.208 378.113 488.208 243.991 C 488.208 109.869 379.479 1.136 245.353 1.136 C 111.231 1.136 2.498 109.869 2.498 243.991 Z M 245.353 464.556 L 245.353 22.847 C 352.03 8.719 471.21 122.069 467.572 243.991 C 475.943 352.139 361.258 473.435 245.353 464.556 Z",
      style: {}
    }, null, -1)
  ])))
}